import React from "react";
import track from "../../helpers/track";
import s from "./style.module.css";
import { EditorState, ContentState } from "draft-js";
import { ReactComponent as Redo } from "./action-redo--m.svg";
import { ReactComponent as Undo } from "./action-undo--m.svg";
import { ReactComponent as Remove } from "./remove--m.svg";

export const Button = ({ children, type, ...rest }) => (
  <button className={s.button} {...rest}>
    <span className={s.cta}>
      <span className={s.icon}>
        {type === "redo" && <Redo />}
        {type === "undo" && <Undo />}
        {type === "clear" && <Remove />}
      </span>

      <span className={s.text}>{children}</span>
    </span>
  </button>
);

const EditorButtons = ({ editorState, update, copy }) => {
  const redo = () => {
    track.redo();
    update(EditorState.redo(editorState));
  };

  const undo = () => {
    track.undo();
    update(EditorState.undo(editorState));
  };

  const clear = () => {
    track.clear();
    update(
      EditorState.moveFocusToEnd(
        EditorState.push(editorState, ContentState.createFromText(""))
      )
    );
  };

  return (
    <div className={s.wrap}>
      <Button onClick={undo} type="undo">
        {copy.undo}
      </Button>
      <Button onClick={redo} type="redo">
        {copy.redo}
      </Button>
      <Button onClick={clear} type="clear">
        {copy.clear}
      </Button>
    </div>
  );
};

export default EditorButtons;
